import { render } from "./Stars.vue?vue&type=template&id=66e76724&scoped=true"
import script from "./Stars.vue?vue&type=script&lang=js"
export * from "./Stars.vue?vue&type=script&lang=js"

import "./Stars.vue?vue&type=style&index=0&id=66e76724&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e76724"],['__file',"resources/js/System/Compenents/Stars.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66e76724"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66e76724', __exports__)) {
    api.reload('66e76724', __exports__)
  }
  
  module.hot.accept("./Stars.vue?vue&type=template&id=66e76724&scoped=true", () => {
    api.rerender('66e76724', render)
  })

}


export default __exports__